export const SHARE_SCOPE = {
  PROPERTY: "property",
  EXPERIENCE: "experience",
  MEDIA_ITEM: "media_item",
} as const;
